"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTextStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
exports.modifiers = {
  small: function small() {
    return {
      styles: "\n      span {\n        ".concat((0, atoms_utils_theme_1.fontSize)(16), ",\n      }")
    };
  },
  secondary: function secondary(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      border-bottom-color: ".concat(theme.farmProject.dark_gray, ";\n      span {\n        color: ").concat(theme.farmProject.dark_gray, ";\n        text-decoration-color: ").concat(theme.farmProject.dark_gray, ";\n      }\n    ")
    };
  },
  inverted: function inverted(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.gray_3, ";\n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n    ")
    };
  },
  brand: function brand(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.brand_primary, ";\n      border-bottom-color: ").concat(theme.farmProject.brand_primary, ";\n      span {\n        color: ").concat(theme.farmProject.brand_primary, ";\n        text-decoration-color: ").concat(theme.farmProject.brand_primary, ";\n      }\n    ")
    };
  },
  underline: function underline() {
    return {
      styles: "\n      span {\n        text-decoration: underline;\n      }\n    "
    };
  },
  underlineContent: function underlineContent() {
    return {
      styles: "\n      text-decoration: underline;\n    "
    };
  },
  underlined: function underlined() {
    return {
      styles: "\n      border-bottom: 1px solid;\n    "
    };
  },
  italic: function italic() {
    return {
      styles: "\n      font-style: italic;\n    "
    };
  },
  fontFamilyText: function fontFamilyText(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: "\n      span {\n        font-family: ".concat(theme.farmProject.font_family_text, ";\n      }\n    ")
    };
  },
  compact: function compact() {
    return {
      styles: "\n      padding: 0;\n      display: unset;\n      span {\n        letter-spacing: normal;\n      }\n    "
    };
  },
  bold: function bold() {
    return {
      styles: "\n      font-weight: bold;\n    "
    };
  },
  brandHover: function brandHover(_ref5) {
    var theme = _ref5.theme;
    return "\n    :hover,\n    :hover *,\n    :focus * {\n        color: ".concat(theme.farmProject.brand_primary, ";\n        transition: all 0.2s ease;\n      }\n  ");
  },
  textLeft: function textLeft() {
    return {
      styles: "\n      text-align: left;\n      span {\n        text-align: left;\n      }\n    "
    };
  },
  wFull: function wFull() {
    return {
      styles: "\n      width: 100%;\n    "
    };
  }
};
exports.ButtonTextStyled = styled_components_1.default.button.attrs({
  className: 'ButtonText'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: transparent;\n  width: auto;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.25rem;\n  border: none;\n  margin: 0;\n  transition: all 0.125s ease-in-out;\n  cursor: ", ";\n  opacity: ", ";\n  font-weight: normal;\n\n  span {\n    font-family: ", ";\n    font-size: 0.75rem;\n    letter-spacing: 0.05375rem;\n    color: ", ";\n    text-decoration: none;\n  }\n\n  svg {\n    width: 0.75rem;\n    height: 0.75rem;\n    fill: ", ";\n    margin-left: 0.25rem;\n  }\n\n  &:hover {\n  }\n\n  ", ";\n"])), function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? '0.7' : '1';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.farmProject.font_family;
}, function (_ref9) {
  var theme = _ref9.theme,
    disabled = _ref9.disabled;
  return disabled ? theme.farmProject.gray_2 : theme.farmProject.green;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.farmProject.green;
}, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));